import { createSelector } from "reselect";
import { AppState } from "../appState";
import { ETab } from "../../constants";
import { tabPositionSelector } from "./tabSelectors";

// Base selectors
const overagesPageSelector = (state: AppState) => state.overageListPageObject;
const myAssignmentsPageSelector = (state: AppState) =>
  state.myAssignmentPageObject;
const shortagesPageSelector = (state: AppState) => state.shortagesPageObject;
const damagesPageSelector = (state: AppState) => state.damagesPageObject;
const searchExceptionPageSelector = (state: AppState) =>
  state.searchExceptionPageObject;
const onHandDeliveryPageSelector = (state: AppState) =>
  state.onHandDeliveryPageObject;
export const misdeliveryPageSelector = (state: AppState) =>
  state.misdeliveryPageObject;
// Memoized selector to get Pagination page object based on tab position
export const pageSelector = createSelector(
  [
    tabPositionSelector,
    overagesPageSelector,
    myAssignmentsPageSelector,
    shortagesPageSelector,
    damagesPageSelector,
    onHandDeliveryPageSelector,
    searchExceptionPageSelector,
    misdeliveryPageSelector,
  ],
  (
    tabPosition,
    overagesPageObject,
    myAssignmentsPageObject,
    shortagesPageObject,
    damagesPageObject,
    onHandDeliveryPageObject,
    searchExceptionPageObject,
    misdeliveryPageObject,
  ) => { // NOSONAR
    const pageObjectMap = {
      [ETab.overages]: overagesPageObject,
      [ETab.myAssignments]: myAssignmentsPageObject,
      [ETab.damages]: damagesPageObject,
      [ETab.onHandDelivery]: onHandDeliveryPageObject,
      [ETab.shortages]: shortagesPageObject,
      [ETab.dashboard]: searchExceptionPageObject,
      [ETab.misdelivery]: misdeliveryPageObject,
    } as const;

    return (
      pageObjectMap[tabPosition as keyof typeof pageObjectMap] ??
      shortagesPageObject
    );
  }
);

const overagesSortSelector = (state: AppState) => state.overageSortObjectData;
const myAssignmentsSortSelector = (state: AppState) =>
  state.myAssignmentSortObjectData;
const shortagesSortSelector = (state: AppState) => state.shortagesSortObject;
const damagesSortSelector = (state: AppState) => state.damagesSortObject;
const onHandDeliverySortSelector = (state: AppState) =>
  state.onHandDeliverySortObject;
const searchExceptionSortSelector = (state: AppState) =>
  state.searchExceptionSortObject;

// Memoized selector to get data table sorting based on tab position
// Additional selectors for misdelivery tab

export const misdeliverySortSelector = (state: AppState) =>
  state.misdeliverySortObject;
export const sortSelector = createSelector(
  [
    tabPositionSelector,
    overagesSortSelector,
    myAssignmentsSortSelector,
    shortagesSortSelector,
    damagesSortSelector,
    onHandDeliverySortSelector,
    searchExceptionSortSelector,
    misdeliverySortSelector,
  ],
  (
    tabPosition,
    overagesSortSelector,
    myAssignmentsSortSelector,
    shortagesSortSelector,
    damagesSortSelector,
    onHandDeliverySortSelector,
    searchExceptionSortSelector,
    misdeliverySortSelector,
  ) => { // NOSONAR
    const sortSelectorMap = {
      [ETab.overages]: overagesSortSelector,
      [ETab.myAssignments]: myAssignmentsSortSelector,
      [ETab.damages]: damagesSortSelector,
      [ETab.onHandDelivery]: onHandDeliverySortSelector,
      [ETab.shortages]: shortagesSortSelector,
      [ETab.dashboard]: searchExceptionSortSelector,
      [ETab.misdelivery]: misdeliverySortSelector,
    } as const;

    return (
      sortSelectorMap[tabPosition as keyof typeof sortSelectorMap] ??
      shortagesSortSelector
    );
  }
);

